import type { ReactNode } from 'react';

export function Card({ title, hint, action, children, className = '', tone, label, flush }: { title?: ReactNode; hint?: ReactNode; action?: ReactNode; children?: ReactNode; className?: string; tone?: 'critical' | 'amber' | 'blue'; label?: string; flush?: boolean }) {
  return (
    <section className={`card ${tone ? `card-${tone}` : ''} ${className}`} aria-label={label ?? (typeof title === 'string' ? title : undefined)}>
      {(title || action || hint) && (
        <div className={`card-head ${flush ? '' : 'ruled'}`}>
          <div>
            {title && <h2>{title}</h2>}
            {hint && <div className="card-hint">{hint}</div>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
